import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { DsButtonDirective, DsCardDirective } from '../ui';

@Component({
  selector: 'app-not-found-page',
  imports: [RouterLink, DsButtonDirective, DsCardDirective],
  templateUrl: './not-found-page.html',
  styleUrl: './not-found-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPage {
  private readonly document = inject(DOCUMENT);
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);

  constructor() {
    this.title.setTitle('Page not found | IQLabTest');
    this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });
    this.meta.updateTag({
      name: 'description',
      content:
        'The requested IQLabTest page could not be found. Continue to the assessment or IQ knowledge center.',
    });
    this.document.head.querySelector('link[rel="canonical"]')?.remove();
  }
}
